var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ppah",attrs:{"data-test":"pp-action-host"}},[_c('div',{staticClass:"ppah__lift",attrs:{"data-test":"pp-action-lift"}},[(_vm.txPlansOpen)?_c('PatientTxPlansModal'):_vm._e(),(_vm.sendPlanOpen)?_c('SendPlanModal',{attrs:{"patient":_vm.sendPlanPatient,"timezone":_vm.gates.smsOptOutTimezone}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }